module.exports = {
  announcement_list_content: require('../hbs/announcement_list_content.hbs'),
  article_list_content: require('../hbs/article_list_content.hbs'),
  birthday_set_confirm: require('../hbs/birthday_set_confirm.hbs'),
  birthday_set_popup: require('../hbs/birthday_set_popup.hbs'),
  children_info: require('../hbs/children_info.hbs'),
  question: require('../hbs/question.hbs'),
  sponsored_article: require('../hbs/sponsored_article.hbs')
};



// WEBPACK FOOTER //
// ./webroot/js/template.js